import { queryKeys } from '@query/keys'
import { useQuery } from '@tanstack/react-query'
import { useLocation } from 'react-router-dom'

import { useSessionLanguage } from '@context/SessionSettingsContext'

import { useApiClient } from '@utils/ApiClient'
import { ClientApiClient } from '@utils/clientApi'
import { getTickmillCompanyByHostname } from '@utils/companyName.utils'
import { getLocationCountry } from '@utils/geolocation'

export const useFetchRegulators = () => {
  const apiClient = useApiClient(ClientApiClient)
  const locale = useSessionLanguage()
  const location = useLocation()
  const locationCountry = getLocationCountry(location)
  const tickmillCompanyId = getTickmillCompanyByHostname(true)

  const { data, isLoading } = useQuery({
    queryKey: queryKeys.regulators(tickmillCompanyId, locale, locationCountry),
    queryFn: () => apiClient.getRegulators(tickmillCompanyId, locale, locationCountry),
    enabled: !!locale,
    staleTime: 30 * 60 * 1000,
    gcTime: 60 * 60 * 1000,
  })

  return { isLoading, data: data || [] }
}
